// extracted by mini-css-extract-plugin
export default {"buttonSection":"ViewApplication_buttonSection__Qmasb","publishButton":"ViewApplication_publishButton__hGLZv","closeButton":"ViewApplication_closeButton__ZQOeZ"};